export default "__VITE_PUBLIC_ASSET__49bdd352__"